export default "__VITE_ASSET__477ece33__"